import { useEffect, useRef, useState } from "react";
import BookingDataService from "../../services/Booking";
import { useNavigate } from "react-router-dom";
import { useDisclosure, useToast } from "@chakra-ui/react";
import { SingleProvisionalBookingRow } from "../../components/List/SingleProvisionalBookingRow";
import { AiFillLock, AiFillUnlock } from "react-icons/ai";
import { BsInfoCircleFill } from "react-icons/bs";
import { ClipLoader } from "react-spinners";
import SyncDateModal from "../../components/Modals/SyncDateModal";

export const ProvisionalBookingList = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const storedcontrols = localStorage.getItem("logged_in_user_accesscontrols");
  const localSearch =
    localStorage.getItem("provisional_booking-list-search-content") || "";
  const userControls: any[] = storedcontrols ? JSON.parse(storedcontrols) : [];
  const [isLoading, setIsLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [syncWixLoading, setSyncWixLoading] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();
  const [list, setList] = useState<any>();
  const [modal, setModal] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState(localSearch);
  const [totalPages, setTotalPages] = useState(0);
  const [totalBookings, setTotalBookings] = useState(0);
  const [recentBookings, setRecentBookings] = useState(0);
  const [currentMonthBookings, setcurrentMonthBookings] = useState(0);
  const hasAutoSyncedRef = useRef(false);
  const isNgodelete = (isdelete: true) => {
    fetchData();
  };

  const [lock, setLock] = useState({
    searchLock: localSearch !== "" ? true : false,
  });

  const fetchData = async () => {
    BookingDataService.getNonAppBookings(page, pageSize, token, search)
      .then((res: any) => {
        setList(res.data.data);
        setTotalPages(res.data.totalPages);
        setTotalBookings(res.data.totalBookings);
        setRecentBookings(res.data.recentBookings);
        setcurrentMonthBookings(res.data.currentMonthBookings);
      })
      .catch((error: any) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  const syncWixBookings = (date: string, showSuccessToast = true) => {
    setSyncWixLoading(true);
    BookingDataService.syncWixProvisionalBookings(date)
      .then((res) => {
        setSyncWixLoading(false);
        fetchData();
        if (showSuccessToast) {
          toast({
            position: "top",
            title: "Wix Bookings Updated Successfully.",
            // description: "Wix Bookings are updated successfully.",
            status: "success",
            duration: 1000,
            isClosable: true,
          });
        }
      })
      .catch((e) => {
        setSyncWixLoading(false);
        if (e.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
        }
        console.log(e);
      });
  };

  useEffect(() => {
    fetchData();
  }, [page, pageSize]);

  useEffect(() => {
    if (hasAutoSyncedRef.current) {
      return;
    }
    hasAutoSyncedRef.current = true;
    const today = new Date().toISOString().slice(0, 10);
    syncWixBookings(today, false);
  }, []);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Bookings - Provisional Bookings</div>
      <div className="p-4">
        {/* top section */}
        <div className="top_section_container">
          <div className="expert_container_item expert_list_button ">
            <div className="input-group">
              <input
                className="form-control filter-sec"
                id="lead_status"
                placeholder="Search booking by user and expert name."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />

              <div className="input-group-append">
                <button
                  className="btn action-btn"
                  type="button"
                  onClick={() => {
                    setPage(1);
                    fetchData();
                  }}
                >
                  Search
                </button>

                <div className="input-group-append ">
                  {lock.searchLock ? (
                    <button
                      className="btn action-btn"
                      style={{ backgroundColor: "#308888" }}
                      type="button"
                      onClick={() => {
                        setLock({ ...lock, searchLock: false });
                        setSearch("");
                        localStorage.removeItem(
                          "provisional_booking-list-search-content"
                        );
                      }}
                    >
                      <AiFillLock
                        style={{ fontSize: "20px", margin: "0 5px" }}
                      />
                    </button>
                  ) : (
                    <button
                      className="btn action-btn"
                      style={{ backgroundColor: "#308888" }}
                      type="button"
                      onClick={() => {
                        setLock({ ...lock, searchLock: true });
                        localStorage.setItem(
                          "provisional_booking-list-search-content",
                          search
                        );
                      }}
                    >
                      <AiFillUnlock
                        style={{ fontSize: "20px", margin: "0 5px" }}
                      />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="expert_container_item expert_list_button ">
            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={() => navigate("/provisional/bookings/add")}
              >
                Add New Booking
              </button>
            </div>
          </div>
        </div>
        <div className="sync-wix mt-2 pl-1">
          <div>
            <button
              className="btn action-btn search-btn"
              type="button"
              onClick={() => {
                setModal("syncDate");
                onOpen();
              }}
            >
              Sync Wix Bookings
            </button>
          </div>
          <div>
            <ClipLoader
              color="#fdb508"
              size={20}
              cssOverride={{
                visibility: syncWixLoading ? "visible" : "hidden",
              }}
            />
          </div>
        </div>
        {modal === "syncDate" && (
          <SyncDateModal
            isOpen={isOpen}
            onClose={onClose}
            func={syncWixBookings}
          />
        )}
        {/* Booking Count */}
        {/* <div className="booking-text">
          Bookings we had in 24 hr : <span className="booking-count">{recentBookings}</span>
        </div> */}
        {/* <div className="parent-booking-count">
          <div className="info-icon">
            <BsInfoCircleFill color="#fdb508" fontSize="24px" />
          </div>
          <div className="info-content p-3 bg-light ml-2">
            <div className="booking-text">
              Bookings we had today :{" "}
              <span className="booking-count">{recentBookings}</span>
            </div>
            <div className="booking-text">
              Bookings we had this month :{" "}
              <span className="booking-count">{currentMonthBookings}</span>
            </div>
          </div>
        </div> */}

        {/* Main secttion */}
        <div className="main-section">
          <table className="table">
            <thead>
              <tr>
                {userControls.includes("bookingEditing") && <th>Edit</th>}
                <th>Booking Id</th>
                <th>Lead Name</th>
                <th>Expert Name</th>
                <th>Booking Date</th>
                <th>Session Date</th>
                <th>Booking Type</th>
                <th>Booking Status</th>
                <th>Booking Post Session Status</th>
                <th>View</th>
                {userControls.includes("provisionalBookingApproval") && (
                  <th>Approval</th>
                )}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {list && list.length > 0 ? (
                list.map((el: any) => (
                  <SingleProvisionalBookingRow
                    key={el._id}
                    props={el}
                    id={el._id}
                    func={isNgodelete}
                  />
                ))
              ) : (
                <h1 className="no-data">No Data Found</h1>
              )}
            </tbody>
          </table>
        </div>
        <div className="row m-0 pagination pt-5">
          <div className="col-sm-6 p-lg-0">
            <p>
              Showing {(page - 1) * pageSize + 1} to{" "}
              {page * pageSize > totalBookings
                ? totalBookings
                : page * pageSize}{" "}
              of {totalBookings} entries
            </p>
          </div>
          <div className="col-sm-6 p-lg-0 text-right">
            <div className="btn-group" role="group">
              <button
                type="button"
                className={
                  page === 1
                    ? "btn action-btn disabledButton "
                    : "btn action-btn"
                }
                onClick={() => setPage(page - 1)}
                disabled={page === 1 ? true : false}
              >
                {"<< Previous"}
              </button>
              <button type="button" className="btn action-btn selected">
                {page}
              </button>
              <button
                type="button"
                className={
                  page === totalPages || totalPages === 0
                    ? "btn action-btn disabledButton "
                    : "btn action-btn"
                }
                onClick={() => setPage(page + 1)}
                disabled={
                  page === totalPages || totalPages === 0 ? true : false
                }
              >
                {"Next >>"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
